import { render } from "./HowToUse.vue?vue&type=template&id=f56fe764"
import script from "./HowToUse.vue?vue&type=script&lang=js"
export * from "./HowToUse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__